import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/app-preferences.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppPreferencesProvider } from "./context/AppPreferencesContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AppPreferencesProvider>
      <App />
    </AppPreferencesProvider>
  </React.StrictMode>
);

reportWebVitals();